<template>
<el-container>
  <el-main>
    <!-- 租客退租 -->
    <el-dialog
      :title="$t('tenant.chooseChekcOutRoom')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="checkOutVisible"
      width="400px"
     > 
      <el-form :inline="true" class="demo-form-inline" style="margin-top:-20px">
          <el-form-item :label="$t('tenant.tenantName')">
            {{this.currentCheckOutTenantData.tenantName}}
          </el-form-item>  
          <el-form-item :label="$t('tenant.chcekOut')">
           <el-select v-model="checkOutForm.roomId" filterable :placeholder="$t('tenant.chooseChekcOutRoom')" style="width:220px" @change="roomSelectChange">
            <el-option
             v-for="item in checkOutForm.selectRoomData"
             :key="item.roomId"
             :label="item.roomName"
             :value="item.roomId">
            </el-option>
           </el-select>
          </el-form-item> 
           <el-form-item :label="$t('systemRecord.beginTime')" label-width="80px">
             {{this.checkOutForm.beginTime}}
          </el-form-item> 
          </br>
          <el-form-item :label="$t('systemRecord.endTime')" label-width="80px">
             {{this.checkOutForm.endTime}}
          </el-form-item>  
       
      </el-form>
     
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmCheckOut">{{$t('tenant.confirm')}}</el-button>
        <el-button type="primary" @click="checkOutVisible = false;">{{$t('tenant.cancel')}}</el-button>
        
      </div>
    </el-dialog>
    <!-- 选择公寓 -->
    <el-dialog
      :title="$t('tenant.chooseApartment')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="apartmentListVisible"
      width="550px"
      style="margin-top:-30px"
     > 
      <el-form :inline="true" class="demo-form-inline" style="margin-top:-20px">
      <el-form-item :label="$t('tenant.apartmentName')">
         <el-input v-model="selectApartmentForm.apartmentName" clearable placeholder="请输入租客名称"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="onSelectApartment">{{$t('tenant.qurey')}}</el-button>
      </el-form-item>
      </el-form>
      <el-table
        ref="singleTable"
        :data="apartmentList"
        highlight-current-row
        @current-change="handleCurrentChangeDetail"
        height=280px
        style="margin-top:-10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="apartmentName"
          :label="$t('tenant.apartmentName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="apartmentType"
          :label="$t('tenant.apartmentType')"
          :formatter="this.$util.apartmentTypeFormat"
          width="80"
        >
        </el-table-column>
      
        <el-table-column prop="" :label="$t('tenant.area')" align="center" width="200px">
         <template slot-scope="scope">
           {{scope.row.province}} - {{scope.row.city}} - {{scope.row.area}}
         </template> 
        </el-table-column>
        <el-table-column
          property="apartmentAddress"
          :label="$t('tenant.address')"
          width="120"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="apartmentTotal"
          :offset="apartmentPageData.offset"
          :pageSize="apartmentPageData.pageNumber"
          @handleSizeChangeSub="apartmentHandleSizeChange"
          @handleCurrentChangeSub="apartmentHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseApartment">{{$t('tenant.confirmChoose')}}</el-button>
        <el-button type="primary" @click="checkInVisible = true;apartmentListVisible = false;">{{$t('tenant.cancel')}}</el-button>
      </div>
    </el-dialog>
    <!-- 租客入住 -->
    <el-dialog
      :title="$t('tenant.tenantCheckIn')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="checkInVisible"
      width="800px"
      style="margin-top:-80px"
    >
      <el-form
        :inline="true"
        :model="checkInForm"
        ref="checkInForm"
        class="demo-ruleForm"
        style="margin-top:-25px"
      >

      <el-form-item :label="$t('tenant.name')" label-width="150px">
          {{checkInForm.tenantName}}
      </el-form-item> 



      <el-form-item :label="$t('tenant.mobile')" label-width="150px">
         {{checkInForm.tenantPhone}}
      </el-form-item>


      <el-form-item :label="$t('tenant.email')"  label-width="150px">
          {{checkInForm.email}}
      </el-form-item>


      <el-form-item
        :label="$t('tenant.roomResource')"
        label-width="150px"
        prop="roomAddress"
        :rules="[{ required: true,message:this.$t('tenant.roomResource-input')}]"
      >
       <el-col :span="18">
         <el-input
          v-model="checkInForm.roomAddress"
          :placeholder="$t('tenant.roomResourceAddress')"
          maxlength="8"
         ></el-input>
       </el-col>  
       <el-col :span="6" style="display:flex;justify-content:center;align-items:center;">
        <el-button size="medium" :title="$t('tenant.chooseApartment')" icon="el-icon-search" type="primary" @click="chooseApartment"></el-button>
       </el-col>
      </el-form-item> 
       
      <el-form-item :label="$t('apartmentDetail.floor')"  label-width="100px">
          <el-select style="width:90%" @change="floorChoose" v-model="checkInForm.floorId" filterable :placeholder="$t('tenant.choose')">
            <el-option
             v-for="item in checkInForm.floorList"
            :key="item.floorId"
            :label="item.floorName"
             :value="item.floorId">
           </el-option>
          </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('tenant.roomName')"
          label-width="150px"
          prop="roomName"
          :rules="[{ required: true, message:this.$t('tenant.roomResource-input')}]"
      >
          <el-select style="width:90%" @change="roomChoose" v-model="checkInForm.roomName" filterable :placeholder="$t('tenant.choose')">
            <el-option
             v-for="item in checkInForm.roomList"
            :key="item.roomId"
            :label="item.roomName"
             :value="item.roomId">
           </el-option>
          </el-select>
         <!-- <el-select style="width:90%" @change="roomChoose" v-model="checkInForm.roomName" filterable :placeholder="$t('tenant.choose')">
          <el-option-group
            v-for="group in this.apartmentBuildingData.floorList"
            :key="group.floorId"
            :label="group.floorName">
           <el-option
              v-for="item in group.roomList"
             :key="item.roomId"
             :label="showRoomDetail(item)"
             :value="item.roomId"
             :disabled="item.isBindDevice==0"
             >
            
            </el-option>
          </el-option-group>
         </el-select> -->
      </el-form-item>  

     <el-form-item
          :label="$t('tenant.tenantStatus')"
          label-width="150px"
          prop="roomName"
      >
           <el-radio-group v-model="checkInForm.manage" size="mini" style="width:200px">
              <el-tooltip :content="$t('tenant.tenantOnlyOpenDoor')" placement="top" effect="light">
                <el-radio label="0">{{$t('tenant.tenant')}}</el-radio>
              </el-tooltip>
              <el-tooltip :content="$t('tenant.adminLockManage')" placement="top" effect="light">
                <el-radio label="1">{{$t('tenant.admin')}}</el-radio>
              </el-tooltip>
            </el-radio-group>
      </el-form-item>    
        
     
      
      <el-form-item :label="$t('tenant.authType')" style="width:620px;margin-top:-20px" label-width="150px">
          <el-radio v-model="checkInForm.validType" label='0'>{{$t('tenant.password')}}</el-radio>
          <el-radio v-model="checkInForm.validType" label='1'>{{$t('tenant.doorCard')}}</el-radio>
          <el-radio v-model="checkInForm.validType" label='2'>{{$t('tenant.IDCard')}}</el-radio>
          <el-radio v-model="checkInForm.validType" label='3'>{{$t('tenant.fingerprint')}}</el-radio>
         
      </el-form-item>  
      <el-form-item style="width:500px;margin-top:-20px" label-width="150px">
        <el-input
              v-show="checkInForm.validType==0"
              v-model="checkInForm.validData"
              :placeholder="$t('tenant.inputAuthContent')"
              style="margin-left:150px;width:300px"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('tenant.isSendmessage')" label-width="150px" prop="mobile" style="width:450px;margin-top:-15px">
        <el-radio v-model="checkInForm.sendMessageChecked" label>{{$t('tenant.noSend')}}</el-radio>
        <el-radio v-model="checkInForm.sendMessageChecked" label="0">{{$t('tenant.sendSMS')}}</el-radio>
        <el-radio v-model="checkInForm.sendMessageChecked" label="1">{{$t('tenant.sendEmail')}}</el-radio>
      </el-form-item>
       
      <el-form-item
          :label="$t('tenant.beginTime')"
          label-width="150px"
          style="margin-top:-10px"
          prop="date1"
          :rules="[{ required: true, message: this.$t('tenant.beginTime-input')}]"
        >
          <el-date-picker
            type="date"
            :placeholder="$t('tenant.chooseDate')"
            v-model="checkInForm.date1"
            style="width:200px;"
            :disabled="checkInForm.isCheckin"
          ></el-date-picker>
          -
          <!-- <el-time-picker
            placeholder="选择时间"
            v-model="formTenant.time1"
            style="width:150px"
          ></el-time-picker> -->
          <el-time-select
            v-model="checkInForm.time1"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:30'
            }"
            style="width:150px"
            :disabled="checkInForm.isCheckin"
            :placeholder="$t('tenant.chooseDate')">
          </el-time-select>
        </el-form-item>

        <el-form-item
          :label="$t('tenant.endTime')"
          label-width="150px"
          prop="date2"
          style="margin-top:-10px"
          :rules="[{ required: true, message:this.$t('tenant.endTime-input')}]"
        >
          <el-date-picker
            type="date"
            :placeholder="$t('tenant.chooseDate')"
            v-model="checkInForm.date2"
            style="width:200px"
            :disabled="checkInForm.isCheckin"
          ></el-date-picker>
          -
          <!-- <el-time-picker
            placeholder="选择时间"
            v-model="formTenant.time2"
            style="width:150px"
          ></el-time-picker> -->
          <el-time-select
            v-model="checkInForm.time2"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:30'
            }"
            style="width:150px"
            :disabled="checkInForm.isCheckin"
            :placeholder="$t('tenant.chooseDate')">
          </el-time-select>
        </el-form-item>
         
      <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="confirmCheckIn">{{$t('tenant.confirmCheckIn')}}</el-button>
          <el-button type="primary" @click="checkInVisible=false">{{$t('tenant.cancel')}}</el-button>
      </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加/编辑租客信息 -->
    <el-dialog
        :title="tanantTitle"
        :modal-append-to-body="false"
        :lock-scroll="false"
        :visible.sync="addTenantVisible"
        width="750px"
        style="margin-top:-80px"
      >
        <el-form :inline="true" :model="formTenant" ref="formTenant" class="demo-ruleForm" style="margin-top:-20px">
          <el-form-item :label="$t('tenant.tenantName')" label-width="120px" prop="tenantName" :rules="[{ required: true, message:this.$t('tenant.tenantName-input')}]">
            <el-input
              v-model="formTenant.tenantName"
              :placeholder="$t('tenant.tenantName')"
              maxlength="8"
              show-word-limit
              style="width:200px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$t('tenant.IDCard')"
            label-width="120px"
            prop="tenantIdentityId"
            style="margin-top:-5px"
          >
          <el-input
              v-model="formTenant.tenantIdentityId"
              :placeholder="$t('tenant.IDCard')"
              style="width:200px"
            ></el-input>
          </el-form-item>

          <el-form-item
           :label="$t('tenant.cardNo')"
            label-width="120px"
            prop="cardNo"
            style="margin-top:-5px"
          >
          <el-input
              v-model="formTenant.cardNo"
              :placeholder="$t('tenant.cardNo')"
              maxlength="18"
              style="width:150px"
            ></el-input>
           <el-button type="primary" size="small" :title="$t('tenant.edit')" @click="readCard">{{$t('tenant.readCardNo')}}</el-button>
          </el-form-item>

          <el-form-item
            :label="$t('tenant.mobile')"
            label-width="110px"
            prop="mobile"
            style="margin-top:-10px"
          >
            <el-input
              v-model="formTenant.tenantPhone"
              :placeholder="$t('tenant.mobile')"
              maxlength="12"
              show-word-limit
              style="width:200px"
            ></el-input>
          </el-form-item>
          
          <el-form-item
            :label="$t('tenant.email')"
            label-width="120px"
            prop="email"
            style="margin-top:-10px"
           
          >
            <el-input
              v-model="formTenant.tenantEmail"
              :placeholder="$t('tenant.email')"
              style="width:200px"
            ></el-input>
          </el-form-item>

           <el-form-item
            :label="$t('tenant.tenantLable')"
            label-width="120px"
            prop="tenantTag"
            style="margin-top:-10px"
          >
            <el-input
              type="textarea"
              v-model="formTenant.tenantTag"
              maxlength="20"
              style="width:200px"
            ></el-input>
          </el-form-item> 
      <el-card class="box-card">
        <el-form-item :label="$t('tenant.fingerType')" label-width="100px">
          <el-select v-model="formTenant.fingerType" :placeholder="$t('tenant.choose')">
          <el-option
           v-for="item in fingerprintTypeList"
           :key="item.value"
           :label="item.label"
           :value="item.value">
           </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
         :label="$t('tenant.choose')"
         label-width="120px">
          <el-select
            v-model="collectorType"
            style="width:200px"
            :placeholder="$t('tenant.chooseFingerType')"
          >
           <el-option
            v-for="item in collectorList"
            :key="item.value"
            :label="item.lable"
            :value="item.value">
           </el-option>
          </el-select>
        </el-form-item>
      
        <el-form-item :label="$t('tenant.collector')" label-width="100px" v-show="collectorType==0">
          <el-select v-model="formTenant.fingerprintDeviceId" filterable :placeholder="$t('tenant.collector')">
           <el-option
           v-for="item in devicePageData.deviceData"
           :key="item.deviceId"
           :label="item.deviceName"
           :value="item.deviceId">
           </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('tenant.fingerprintId')" label-width="120px">
           <el-input type="text" v-model="formTenant.fingerprintId" disabled placeholder=""  style="width:140px" show-word-limit></el-input>
           <el-button type="primary" @click="collectFingerprint" size="small">{{$t('tenant.collect')}}</el-button>
        </el-form-item>
      </el-card>
      <el-form-item style="margin-top:10px">
            <!-- <el-button type="danger" v-show="formTenant.optionType==1&&formTenant.status==1" @click="checkOut()">{{$t('tenant.checkOut')}}</el-button> -->
            <el-button type="primary" @click="confirmAddTenant()">{{$t('tenant.confirm')}}</el-button>
            <el-button type="primary" @click="addTenantVisible=false">{{$t('tenant.cancel')}}</el-button>
      </el-form-item>
      </el-form>
    </el-dialog>

    <el-form :inline="true" :model="selectForm" class="demo-form-inline">
        <el-form-item :label="$t('tenant.tenantName')">
          <el-input style="width:280px" v-model="selectForm.tenantName" :placeholder="$t('checkInMoreRoom.moreTenantNameSelectMsg')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('tenant.status')">
          <el-select v-model="selectForm.status" :placeholder="$t('tenant.status')" style="width:150px">
            <el-option :label="$t('tenant.all')" value></el-option>
            <el-option :label="$t('tenant.noShow')" value="0"></el-option>
            <el-option :label="$t('deviceApartmentDetail.checkIn')" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('tenant.tenantType')">
          <el-select v-model="selectForm.tenantType" :placeholder="$t('tenant.tenantType')" style="width:150px">
            <el-option :label="$t('tenant.all')" value></el-option>
            <el-option :label="$t('tenant.consumer')" value=0></el-option>
            <el-option :label="$t('tenant.admin')" value=1></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSelect">{{$t('tenant.qurey')}}</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">{{$t('tenant.addTenant')}}</el-button>
          <!-- <download-excel class="export-excel-wrapper" :data="json_data" :fields="json_fields" name="导出租客列表.xls">
            <el-button type="primary" size="small">导出EXCEL</el-button>
          </download-excel>
          <vue-xlsx-table @on-select-file="handleSelectedFile">批量导入</vue-xlsx-table> -->
        </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        empty-text="No Data"
        border
      >
        <el-table-column type="index" :label="$t('tenant.number')" width="100" align="center"></el-table-column>
        <el-table-column prop="tenantName" :label="$t('tenant.tenantName')" align="center"></el-table-column>
        <el-table-column prop="tenantIdentityId" :label="$t('tenant.IDCard')" align="center">
           <template slot-scope="scope">
             {{scope.row.tenantIdentityId=="null"||scope.row.tenantIdentityId=="undefined"?"":scope.row.tenantIdentityId}}
           </template> 
        </el-table-column>
        <el-table-column
           prop="fingerType"
           :label="$t('tenant.fingerType')"
           align="center"
           >
           <template slot-scope="scope">
             {{scope.row.fingerType==0?$t('tenant.undefined'):scope.row.fingerType==1?$t('tenant.leftThumb'):scope.row.fingerType==2?$t('tenant.leftIndexFinger'):scope.row.fingerType==3?$t('tenant.leftHandMiddleFinger'):scope.row.fingerType==4?$t('tenant.ringFingerOfLeftHand'):scope.row.fingerType==5?$t('tenant.leftTailToRefer'):
             scope.row.fingerType==6?$t('tenant.rightThumb'):scope.row.fingerType==7?$t('tenant.rightIndexFinger'):scope.row.fingerType==8?$t('tenant.rightHandMiddleFinger'):scope.row.fingerType==9?$t('tenant.ringFingerOfRightHand'):scope.row.fingerType==10?$t('tenant.rightTailToRefer'):""}}
           </template>  
          </el-table-column>
        <el-table-column
           prop="cardNo"
           :label="$t('tenant.cardNo')"
           align="center"
           >
        </el-table-column>   
        <el-table-column prop="tenantPhone" :label="$t('tenant.mobile')" align="center">
           <template slot-scope="scope">
             {{scope.row.tenantPhone=="null"||scope.row.tenantPhone=="undefined"?"":scope.row.tenantPhone}}
           </template> 
        </el-table-column>
        <!-- <el-table-column prop="tenantEmail" :label="$t('tenant.email')" align="center">
           <template slot-scope="scope">
             {{scope.row.tenantEmail=="null"||scope.row.tenantEmail=="undefined"?"":scope.row.tenantEmail}}
           </template>  
        </el-table-column> -->
        <el-table-column prop="checkInRoomNames" min-width="120" :label="$t('update.checkInRoom')" align="center">
            <template slot-scope="scope">
              {{roomListShow(scope.row.checkInRoomNames)}}
            </template>  
        </el-table-column>
        <el-table-column prop="status" :label="$t('tenant.status')" align="center" :formatter="this.$util.tenantStatusFormat"></el-table-column>
        <!-- <el-table-column prop="tenantTag" :label="$t('tenant.tenantLable')" align="center">
           <template slot-scope="scope">
              {{scope.row.tenantTag=="null"||scope.row.tenantTag=="undefined"?"":scope.row.tenantTag}}
           </template>
        </el-table-column> -->
        <el-table-column prop :label="$t('tenant.operate')" width="300" align="center">
          <template slot-scope="scope">
            <el-button style="margin-top:5px" type="primary" size="mini" :title="$t('tenant.checkIn')" @click="checkIn(scope.$index, scope.row)">{{$t('tenant.checkIn')}}</el-button>
            <!-- <el-button style="margin-top:5px" type="danger" size="mini" :title="$t('tenant.checkIOut')" @click="handleCheckOut(scope.$index, scope.row)">{{$t('tenant.checkOut')}}</el-button> -->
            <el-button style="margin-top:5px" type="primary" size="mini" :title="$t('tenant.edit')" @click="handleEdit(scope.$index, scope.row)">{{$t('tenant.edit')}}</el-button>
            <el-button style="margin-top:5px" type="primary" size="mini" :title="$t('tenant.edit')" @click="handleDetail(scope.$index, scope.row)">{{$t('apartmentList.detail')}}</el-button>
            <el-button style="margin-top:5px" type="danger" size="mini" :title="$t('tenant.delete')" @click="handleDel(scope.$index, scope.row)">{{$t('tenant.delete')}}</el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-footer>
      <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-footer>
  </el-main> 
</el-container>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "tenantList", //租客列表
  data() {
    return {
      // importVisible:false,
      // json_fields:{
      //   "头部-诊断名称":"name",
      //   "头部-联系电话":"phone.mobile",
      //   "头部-损坏区域代码":{
      //       field:"phone.landline",
      //       callback: value=>{
      //         return '损坏区域代码 - ${value}';
      //       }
      //   }
      // },
      // json_data:[
      //  {
      //    name:"损坏的组件一",
      //    city:"New York",
      //    country:"erwrw",
      //    birthdate:"1978-03-15",
      //    phone:{
      //      mobile:"123123",
      //      landline:"223232"
      //    }
      //  },
      //  {
      //    name:"损坏的组件二",
      //    city:"New York",
      //    country:"erwrw",
      //    birthdate:"1978-03-15",
      //    phone:{
      //      mobile:"123123",
      //      landline:"223232"
      //    }
      //  },
      // ],
      idCardChange:"",
      currTenantData:"",
      deviceVisible:false,
      currentDeviceRow :"",
      devicePageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         deviceData: [],
      },
     
      apartmentListVisible:false,
      checkInVisible:false,
      addTenantVisible: false,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      selectForm: {
        tenantName: this.$route.query.tenantName==undefined?"":this.$route.query.tenantName,
        status: this.$route.query.status==undefined?"":this.$route.query.status,
        tenantType:""
      },
      formTenant: {//提交表单
        cardNo:"",
        tenantId: "",
        tenantName: "",
        tenantIdentityId:"",
        tenantTag:"",
        tenantPhone: "",
        tenantEmail: "",
        status:0,
        optionType:0,
        roomId:"",
        fingerType:"",
        fingerprintDeviceId:"",
        fingerprintId:"",
      },
      collectorType:0,
      collectorList:[  
          {lable:this.$t('tenant.networkCollector'),value:0},
          {lable:this.$t('tenant.usbCollector'),value:1}
      ],
      fingerprintTypeList:[
            {label:this.$t('tenant.undefined'),value:0},
            {label:this.$t('tenant.leftThumb'),value:1},
            {label:this.$t('tenant.leftIndexFinger'),value:2},
            {label:this.$t('tenant.leftHandMiddleFinger'),value:3},
            {label:this.$t('tenant.ringFingerOfLeftHand'),value:4},
            {label:this.$t('tenant.leftTailToRefer'),value:5},
            {label:this.$t('tenant.rightThumb'),value:6},
            {label:this.$t('tenant.rightIndexFinger'),value:7},
            {label:this.$t('tenant.rightHandMiddleFinger'),value:8},
            {label:this.$t('tenant.ringFingerOfRightHand'),value:9},
            {label:this.$t('tenant.rightTailToRefer'),value:10},
        ],
      confirmDialogState: false,
      tanantTitle: "",
      checkInForm:{
        tenantId:"",
        tenantName:"",
        roomAddress:"",
        tenantPhone:"",
        email:"",
        apartmentId:"",
        buildingId:"",
        floorId:"",
        floorList:[],
        roomList:[],
        roomName:"",
        date1: new Date(),
        time1: this.$util.formatHalfTime(new Date()),
        date2: new Date().setDate(new Date().getDate()+1),
        time2:'12:00',
        sendMessageChecked:"",
        deviceType:"",
        manage:"0",
        validType:'0',
        validData:"",
        isCheckin:false
      },
      apartmentList: [],
      apartmentPageData: {
        offset: 1,
        pageNumber: 10
      },
      apartmentTotal: 1, //总条数
      currentApartmentRow:"",
      apartmentBuildingData:"",
      currentCheckOutTenantData:"",
      checkOutVisible:false,
      selectApartmentForm:{
        apartmetnName:""
      },
      checkOutForm:{
        roomId:"",
        selectRoomData:[],
        beginTime:"",
        endTime:"",
      }
    };
  },
  components: {
    Pagings
  },
  created() {
    this.power();
    this.apartmentPower();
    this.devicePower();
  },
  methods: {
    //读卡
    readCard(){
      //  var parameter={};
      //  parameter.systemCode="11111111";
      //  parameter.hotelCode="22222222";
      //  parameter.cardPass="33333333";
      //  parameter.nBlock="12";
      //  parameter.encrypted="1";
      //  var data = callbackObj.readCardMessage3('3', JSON.stringify(parameter));
       var data = callbackObj.readCardSNWeb();
			 var jsonData = JSON.parse(data); //读取读卡器接口
			  if(jsonData['code'] == 200) {
				   this.formTenant.cardNo=jsonData.data;
			  } else {
				  this.$message({
            message:jsonData.message,
            type: "warning"
          });         
			  }
    },
    //添加授权房间选择
    roomSelectChange(val){
       var roomData= this.checkOutForm.selectRoomData;
       for(var i=0;i<roomData.length;i++){
          if(roomData[i].roomId==val){
             this.checkOutForm.beginTime=this.$util.formartDateTime(roomData[i].beginTime);
             this.checkOutForm.endTime=this.$util.formartDateTime(roomData[i].endTime);
          }
       }
    },
    //导入
    handleSelectedFile(convertedData){
      let data=convertedData.body;
      data.forEach((item)=>{
         alert(JSON.stringify(item));
      })
    },
    //租客退租
    handleCheckOut(index,row){
       console.log(row);
       this.checkOutVisible=true;
       this.currentCheckOutTenantData=row;
       this.getTenantDetail(row.tenantId);
       this.checkOutForm.roomId="";
       this.checkOutForm.roomData=[];
    },
    //采集指纹
    collectFingerprint(){
     var collectorType=this.collectorType;
      if(this.formTenant.fingerType==""||this.formTenant.fingerType==null){
        this.$message({
          message: this.$t('tenant.chooseFingerType'),
          type: "warning"
        });
        return false;
      }
     if(collectorType==0){
      
          if(this.formTenant.fingerprintDeviceId==""||this.formTenant.fingerprintDeviceId==null){
            this.$message({
               message: this.$t('tenant.chooseFingerCollect'),
               type: "warning"
            });
            return false;
          }
          var formData = new FormData();
          formData.append("deviceId",this.formTenant.fingerprintDeviceId);
          this.$server
          .exam("/customer/gateway/collectUserFingerprint", formData)
          .then(data => {
           if (data.code == 200) {
            var rtnData = data["data"];
            const loading = this.$loading({
              lock: true,
              text:this.$t('tenant.collection'),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.rId = rtnData;
            obj.loading = loading;
            obj.othis=this;
            obj.opType = "collectTenantFingerprint";
            this.$store.dispatch("checkResult", obj); //等待回调 
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
      }else{
          var rtnData = JSON.parse(callbackObj.readFingerWeb());
					if(rtnData['code'] == 200) {
						  this.formTenant.fingerprintId=rtnData.data;
              this.$message({
               message:this.$t('tenant.collectionSuccess'),
               type: "success",
              });
					} else {
						this.$message({
              message:rtnData['message'],
              type: "warning",
            });
					}
      }
       
    },
    
    //提交选择指纹类型
    confirmChooseFingerprint(){
         this.chooseFingerprintFlag=false;
         switch(this.addFgDevice.fingerType){
            case "1":
              this.addFgDevice.fingerTypeLable= this.$t('tenant.leftThumb');
              break;
            case "2":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.leftIndexFinger');
              break;
            case "3":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.leftHandMiddleFinger');
              break;
            case "4":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.ringFingerOfLeftHand');
              break;
            case "5":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.leftTailToRefer');
              break;
            case "6":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.rightThumb');
              break;
            case "7":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.rightIndexFinger');
              break;
            case "8":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.rightHandMiddleFinger');
              break;
            case "9":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.ringFingerOfRightHand');
              break;
            case "10":
              this.addFgDevice.fingerTypeLable=this.$t('tenant.rightTailToRefer');
              break;        
         }
    },
    //选择指纹手指类型
    chooseFingerType(){
       this.chooseFingerprintFlag=true;
    },
    //打开选择指纹
    chooseFingerType(){
        this.chooseFingerprintFlag=true;
    },

    //选择设备
    chooseDevice(){
      this.deviceVisible=true;
    },
     //或者选择设备行记录
    handleCurrentChangeDetailDevice(val){
         this.currentDeviceRow=val;
    },
    //确认选择设备
    confirmChooseDevice(){
       this.deviceVisible=false;
       this.addFgDevice.deviceId=this.currentDeviceRow.deviceId;
       this.addFgDevice.deviceName=this.currentDeviceRow.deviceName;
    },
    
    showRoomDetail(roomData){
        var rtn="";
        switch(roomData.status){
           case 0:
               if(roomData.isBindDevice==0){
                  rtn=roomData.roomName+" "+this.$t("tenant.deviceNoBind");
               }else{
                  rtn=roomData.roomName+" "+this.$t("tenant.free");
               }
             break;
           case 1:
               rtn=roomData.roomName+" "+this.$t("tenant.notClean");
             break;  
           case 2:
               rtn=roomData.roomName+" "+this.$t("tenant.Maintained");
             break;
           case 3:
               rtn=roomData.roomName+" "+this.$t("tenant.alreadyCheckIn");
             break; 
            case 4:
               rtn=roomData.roomName+" "+this.$t("tenant.expired");
             break;             
        }
        return rtn
    },
    onSelectApartment(){
       this.apartmentPower();
    },
    //楼层下拉选择
    floorChoose(){
      //获取选择楼层的房间信息
      this.getBaseRoom(this.checkInForm.floorId);
    },
    //房间下拉选择
    roomChoose(){
       this.getRoomData(this.checkInForm.roomName);//获取房间详细
    },
    // 退租
    confirmCheckOut(){
       this.$confirm(this.$t("tenant.checkOutConfirmMsg")+this.formTenant.tenantName+')?', this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("isDelete", 0);
         formData.append("roomId", this.checkOutForm.roomId);
         formData.append("tenantId", this.currentCheckOutTenantData.tenantId);
         this.$server.exam("/customer/apartment/checkOut", formData).then(data => {
          if (data.code == 200) {
            this.checkOutVisible=false;
            this.$message({
              message: data.message,
              type: "success"
            });
            this.power();
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
       });
      }).catch(() => {
        this.$message({
          type: 'info',
          message:this.$t("tenant.cancelCheckOut")
        });          
      });
    },
    //提交入住
    confirmCheckIn(){
      var formData = new FormData();
      var date1 = this.$util.formartDate(this.checkInForm.date1);
      var time1 = this.checkInForm.time1+":00";
      var date2 = this.$util.formartDate(this.checkInForm.date2);
      var time2 = this.checkInForm.time2+":00";
      if (this.checkInForm.time1 == "" || this.checkInForm.time1 == null) {
        this.$message({
          message:this.$t("tenant.beginTime-input"),
          type: "error"
        });
        return false;
      }
      if (this.checkInForm.time2 == "" || this.checkInForm.time2 == null) {
        this.$message({
          message: this.$t("tenant.endTime-input"),
          type: "error"
        });
        return false;
      }
      formData.append("roomId", this.checkInForm.roomName);//roomName获取了roomId
      formData.append("isLimit", 1);
      formData.append("tenantId", this.checkInForm.tenantId);
      formData.append("isManager", parseInt(this.checkInForm.manage));
      var authList = [];
      var authObj = {};
      authObj.authorizationName = this.checkInForm.tenantName;
      authObj.isLocked = 0;
      authObj.isOpen = 0;
      authObj.isOpenPublicDoor = 0;
      authObj.validType =this.checkInForm.validType;
      switch(this.checkInForm.deviceType){
         case 1:
            authObj.validUser = 2;
           break;
         case 2:
            authObj.validUser = 3;
           break
         case 3:
            authObj.validUser = 2;
          break;    
         case 4:
            authObj.validUser = 3;
          break; 
         case 5:
            authObj.validUser = 2;
          break;
         case 6:
            authObj.validUser = 2;
          break;    
      }
      if(this.checkInForm.validType=='0'){
          authObj.validData=this.checkInForm.validData;
      }
     
      formData.append("beginTime", date1 + " " + time1);
      formData.append("endTime", date2 + " " + time2);
      
      //判断是否发送信息
      switch (this.checkInForm.sendMessageChecked) {
        case "": //不发送信息
          authObj.isSendSms = 0;
          break;
        case "0": //发送短信
          authObj.isSendSms = 1;
          authObj.sendChannel = 0;
          authObj.countryId=86;
          if(this.checkInForm.tenantPhone==null||this.checkInForm.tenantPhone==""){
              this.$message({
                message:this.$t("tenant.phoneRegister"),
                type: "success"
              });
             return false;
          }
          authObj.mobile = this.checkInForm.tenantPhone;
          break;
        case "1": //发送邮箱
          authObj.isSendSms = 1;
          authObj.sendChannel = 1;
          authObj.countryId=86;
          if(this.checkInForm.email==null||this.checkInForm.email==""){
              this.$message({
                message:this.$t("tenant.emailRegister"),
                type: "success"
              });
             return false;
          }
          authObj.email = this.checkInForm.email;
          break;
      }
      authList.push(authObj);
      formData.append("authorizationList", window.JSON.stringify(authList));
      formData.append("validDataIsExist",1);
      this.$server.exam("/customer/apartment/checkIn", formData).then(data => {
        if (data.code == 200) {
          this.checkInVisible = false;
          switch (this.checkInForm.deviceType) {
            case 4: //蓝牙锁
              this.$message({
                message: data.message,
                type: "success"
              });
              this.power();
              break;
            case 2: //离线锁
              this.$message({
                message: data.message,
                type: "success"
              });
              this.power();
              break;
            case 5: //NB联网锁   
            case 6: //NB联网锁   
            case 3: //NB联网锁  
            case 1: //联网锁
              // const loading = this.$loading({
              //   lock: true,
              //   text: "Loading",
              //   spinner: "el-icon-loading",
              //   background: "rgba(0, 0, 0, 0.7)"
              // });
              // var obj = {};
              // obj.rId = data.data[0].recordId;
              // obj.loading = loading;
              // obj.opType = "tenantListCheckIn";
              // obj.othis = this;
              // this.$store.dispatch("checkResult", obj); //等待回调
               this.$message({
                message: data.message,
                type: "success"
              });
              this.power();
              break;
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //提交选择公寓
    confirmChooseApartment(){
      if (this.currentApartmentRow == "" || this.currentApartmentRow == null) {
        this.$message({
          message: this.$t("tenant.chooseApartment"),
          type: "warning"
        });
        return false;
      }
      this.checkInVisible = true;
      this.apartmentListVisible = false;
      this.checkInForm.roomAddress = this.currentApartmentRow.apartmentName;
      this.checkInForm.apartmentId= this.currentApartmentRow.apartmentId;
      this.checkInForm.buildingId=this.currentApartmentRow.buildingId
      // this.getApartmentBuilding(this.currentApartmentRow);//获取楼栋房间信息
      this.getFloor(this.currentApartmentRow);
      this.checkInForm.roomName="";
    },
     //选择租客row
    handleCurrentChangeDetail(val) {
      this.currentApartmentRow = val;
    },
    //打开选择公寓
    chooseApartment(){
      this.apartmentListVisible=true;
      this.checkInVisible=false
    },
    // 打开租客入住
    checkIn(index, row){
       this.checkInVisible=true;
       this.checkInForm.tenantId=row.tenantId;
       this.checkInForm.tenantName=row.tenantName;
       this.checkInForm.tenantPhone=row.tenantPhone;
       this.checkInForm.email=row.tenantEmail=='null'?"":row.tenantEmail;
       this.checkInForm.roomAddress="";
       this.checkInForm.apartmentId="";
       this.checkInForm.buildingId="";
       this.checkInForm.floorId="";
       this.checkInForm.floorList="";
       this.checkInForm.roomList="";
       this.checkInForm.roomName="";
       this.checkInForm.isCheckin=false;
       //this.currentApartmentRow="",
       this.apartmentBuildingData=""
    },
    //查询
    onSelect() {
      this.power();
    },

    handleDel(index, row){
      this.$confirm(this.$t("tenant.deleteConfirmMsg1")+row.tenantName+this.$t("tenant.deleteConfirmMsg2"),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("tenantId ", row.tenantId);
          this.$server.exam("/customer/tenant/deleteTenant", formData).then(data => {
           if (data.code == 200) {
            this.$message({
              message: data.message,
              type: "success"
            });
            this.power();
           } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("tenant.cancelDelete")
          });          
      });
    },
    handleAdd() {
      this.addTenantVisible = true;
      this.confirmDialogState = false;
      this.tanantTitle = this.$t("tenant.addTenant");
      this.formTenant = {
        tenantId: "",
        tenantName: "",
        fingerprintId:"",
        cardNo:"",
        tenantPhone: "",
        tenantEmail: "",
        status:0,//新增租客默认未入住
        optionType:0,
        roomId:"",
        cardNo:""
      };
    },
     handleEdit(index, row) {
      this.addTenantVisible = true;
      this.currTenantData=row;
      this.formTenant.tenantId = row.tenantId;
      this.formTenant.tenantName = row.tenantName;
      this.formTenant.tenantIdentityId=row.tenantIdentityId;
      this.formTenant.tenantPhone = row.tenantPhone;
      this.formTenant.tenantEmail =row.tenantEmail;
      this.formTenant.tenantTag = row.tenantTag==undefined|| row.tenantTag=='undefined'?'':row.tenantTag;  
      this.formTenant.cardNo = row.cardNo;
      this.formTenant.fingerType=row.fingerType;
      this.formTenant.fingerprintDeviceId="";
      this.formTenant.fingerprintId=row.fingerprintId;
      this.confirmDialogState = true;
      this.tanantTitle = this.$t("tenant.editTenant");
      this.formTenant.status=row.status;
      this.formTenant.optionType=1;
      this.getTenantData(row.tenantId);//获取租客详情
    },

    handleDetail(index, row) {
       this.$router.push({path: "/tenantDetail",query: {tenantId:row.tenantId}});
    },
    //确定添加/编辑租客
    confirmAddTenant() {
      var path = "";
      var formData = new FormData();
      formData.append("tenantName ", this.formTenant.tenantName);
      formData.append("tenantPhoneCountryId", 86);
      if(this.formTenant.tenantPhone!=""&&this.formTenant.tenantPhone!=null){
        formData.append("tenantPhone",this.formTenant.tenantPhone);
      }
      if(this.formTenant.tenantEmail!=""&&this.formTenant.tenantEmail!=null){
        formData.append("tenantEmail",this.formTenant.tenantEmail);
      }
      if(this.formTenant.tenantTag!=""&&this.formTenant.tenantTag!=null){
        formData.append("tenantTag",this.formTenant.tenantTag);
      }
     
      formData.append("acquisitionMode",this.collectorType);

      if(this.formTenant.fingerprintId!=""&&this.formTenant.fingerprintId!=null){
        formData.append("fingerprintId",this.formTenant.fingerprintId);
      }

      if(this.formTenant.fingerType!=""&&this.formTenant.fingerType!=null){
        formData.append("fingerType",this.formTenant.fingerType);
      }

      if(this.formTenant.cardNo!=""&&this.formTenant.cardNo!=null){
        formData.append("cardNo",this.formTenant.cardNo);
      }
       
      if (this.confirmDialogState) {
        if(this.formTenant.tenantIdentityId!=""&&this.formTenant.tenantIdentityId!=null&& this.currTenantData.tenantIdentityId!=this.formTenant.tenantIdentityId){
          var idCard=this.formTenant.tenantIdentityId;
          var changeIdCard=parseInt(idCard.substring(0,8),16);
          formData.append("tenantIdentityId",changeIdCard);
        }
        formData.append("tenantId", this.formTenant.tenantId);
        path = "/customer/tenant/editTenant";
      } else {
        if(this.formTenant.tenantIdentityId!=""&&this.formTenant.tenantIdentityId!=null){
          var idCard=this.formTenant.tenantIdentityId;
          var changeIdCard=parseInt(idCard.substring(0,8),16);
          formData.append("tenantIdentityId",changeIdCard);
        }
        path = "/customer/tenant/addTenant";
      }
      this.$server.exam(path, formData).then(data => {
        if (data.code == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
        
          this.addTenantVisible = false;
          this.confirmDialogState = false;
          this.power();
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    //根据楼层ID获取房间
    getBaseRoom(floorId){
       var apartmentId=this.checkInForm.apartmentId;
      var buildingId=this.checkInForm.buildingId;
      var formData = new FormData();
      formData.append("apartmentId", apartmentId);
      formData.append("buildingId", buildingId);
      formData.append("floorId", floorId);
      this.$server.exam("/customer/apartment/listBaseRoom", formData).then(data => {
       if (data.code == 200) {
          this.checkInForm.roomList=data.data;
       } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    //根据公寓ID获取楼层
    getFloor(aparmentData){
      var apartmentId=aparmentData.apartmentId;
      var buildingId=aparmentData.buildingId;
      var formData = new FormData();
      formData.append("apartmentId", apartmentId);
      formData.append("buildingId", buildingId);
      this.$server.exam("/customer/apartment/listBaseFloor", formData).then(data => {
       if (data.code == 200) {
          this.checkInForm.floorList=data.data;
       } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
   
    getTenantDetail(tenantId){
      var formData = new FormData();
      formData.append("tenantId", tenantId);
      this.$server.exam("/customer/tenant/getTenantDetail", formData).then(data => {
        if (data.code == 200) {
         
          if(data.data.apartmentRoomTenantLinkers.length>0){
            this.checkOutForm.roomId=data.data.apartmentRoomTenantLinkers[0].roomId;
            this.checkOutForm.beginTime=data.data.apartmentRoomTenantLinkers[0].beginTime==null?'':this.$util.formartDateTime(data.data.apartmentRoomTenantLinkers[0].beginTime);
            this.checkOutForm.endTime=data.data.apartmentRoomTenantLinkers[0].endTime==null?'':this.$util.formartDateTime(data.data.apartmentRoomTenantLinkers[0].endTime);
          }
          this.checkOutForm.selectRoomData=data.data.apartmentRoomTenantLinkers;
          console.log(data.data.apartmentRoomTenantLinkers);
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    getApartmentBuilding(apartmentData){
      var formData = new FormData();
      formData.append("apartmentId", apartmentData.apartmentId);
      // formData.append("status", this.apartmentPageData.pageNumber);
      this.$server.exam("/customer/apartment/listApartmentBuilding", formData).then(data => {
        if (data.code == 200) {
          if(data.data.length>0&&data.data!=null){
             this.apartmentBuildingData = data.data[0];
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    getTenantData(tenantId){
      var formData = new FormData();
      formData.append("tenantId", tenantId);
      // formData.append("status", this.apartmentPageData.pageNumber);
      this.$server.exam("/customer/tenant/getTenantDetail", formData).then(data => {
        if (data.code == 200) {
           this.currentTenantLinker=data.data.apartmentRoomTenantLinkers;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    getRoomData(roomId){
      var formData = new FormData();
      formData.append("roomId", roomId);
      // formData.append("status", this.apartmentPageData.pageNumber);
      this.$server.exam("/customer/apartment/getApartmentRoomDetail", formData).then(data => {
        if (data.code == 200) {
           if(data.data.beginTime!=''&&data.data.beginTime!=null){
               this.checkInForm.date1=this.$util.formartDate(data.data.beginTime);
               this.checkInForm.time1=this.$util.formatHalfTime(new Date(data.data.beginTime));
               this.checkInForm.isCheckin=true;
           }else{
               this.checkInForm.date1=this.$util.formartDate(new Date());
               this.checkInForm.time1=this.$util.formatHalfTime(new Date());
               this.checkInForm.isCheckin=false;
           }
           if(data.data.endTime!=''&&data.data.endTime!=null){
               this.checkInForm.date2=this.$util.formartDate(data.data.endTime);
               this.checkInForm.time2=this.$util.formatHalfTime(new Date(data.data.endTime));
           }else{
               this.checkInForm.date2=this.$util.formartDate(new Date().setDate(new Date().getDate()+1));
               this.checkInForm.time2="12:00";
           }
           var deviceList=data.data.deviceList;
           if(deviceList.length>0){
             for(var str in deviceList){
               if(deviceList[str].deviceType!=0){
                  this.checkInForm.deviceType=deviceList[str].deviceType;
                  break;
               }
             }
           }
          
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //分解入住房间列表
    roomListShow(data){
      var rtn="";
      if(data!=null&&data!=""){
        for(var str in data){
         rtn+=data[str]+",";
        }
        rtn=rtn.substring(0,rtn.length-1);
      }
       return rtn;
    },
    power() {
      var tenantName=this.selectForm.tenantName;
      var status=this.selectForm.status;
      var tenantType=this.selectForm.tenantType;
      var formData = new FormData();
      if(tenantName!=""&&tenantName!=null){
        formData.append("tenantName", tenantName);
      }
      if(status!=""&&status!=null){
        formData.append("status", status);
      }
      if(tenantType!=""&&tenantType!=null){
        formData.append("tenantType", tenantType);
      }
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server.exam("/customer/tenant/listTenant", formData).then(data => {
        if (data.code == 200) {
          this.tableData = data.data.records;
          this.total = data.data.total;
          // this.oAssEquipmentDto.offset = 1;
          // this.oAssEquipmentDto.pageNumber = data.data.pages;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    
    apartmentPower(){
      var formData = new FormData();
      if(this.selectApartmentForm.apartmentName!=""&&this.selectApartmentForm.apartmentName!=null){
        formData.append("apartmentName", this.selectApartmentForm.apartmentName);
      }
      formData.append("pageNo", this.apartmentPageData.offset);
      formData.append("pageSize", this.apartmentPageData.pageNumber);
      this.$server.exam("/customer/apartment/listApartment", formData).then(data => {
        if (data.code == 200) {
          this.apartmentList = data.data.records;
          this.apartmentTotal = data.data.total;
          // this.oAssEquipmentDto.offset = 1;
          // this.oAssEquipmentDto.pageNumber = data.data.pages;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

   
    devicePower(){
          var formData = new FormData();
          formData.append("pageNo", this.devicePageData.offset);
          formData.append("pageSize", this.devicePageData.pageNumber);
          this.$server
          .exam("/customer/gateway/listCardMachine", formData)
          .then(data => {
           if (data.code == 200) {
             this.devicePageData.deviceData = data.data.records;
             this.devicePageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },
   
    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    },
    apartmentHandleSizeChange(val) {
      this.apartmentPageData.pageNumber = val;
      this.apartmentPower();
    },
    apartmentHandleCurrentChange(val) {
      this.apartmentPageData.offset = val;
      this.apartmentPower();
    },
    deviceHandleSizeChange(val) {
      this.devicePageData.pageNumber = val;
      this.devicePower();
    },
    deviceHandleCurrentChange(val) {
      this.devicePageData.offset = val;
      this.devicePower();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/tenant/tenantList.vue